/* MONORETRO V3 — minimal behaviour. No framework, no dependencies. */
(function () {
  'use strict';
  var d = document;

  /* Mobile menu */
  var toggle = d.querySelector('[data-menu-toggle]');
  var menu = d.getElementById('mr-menu');
  if (toggle && menu) {
    var label = toggle.querySelector('.visually-hidden');
    var iconOpen = toggle.querySelector('[data-icon-open]');
    var iconClose = toggle.querySelector('[data-icon-close]');
    var setMenu = function (open) {
      menu.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      d.body.classList.toggle('menu-open', open);
      iconOpen.hidden = open; iconClose.hidden = !open;
      label.textContent = open ? label.getAttribute('data-label-close') : label.getAttribute('data-label-open');
    };
    toggle.addEventListener('click', function () { setMenu(menu.hidden); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) { setMenu(false); toggle.focus(); } });
    window.matchMedia('(min-width: 1024px)').addEventListener('change', function (m) { if (m.matches) setMenu(false); });
  }

  /* Footer selectors submit on change */
  d.querySelectorAll('[data-autosubmit]').forEach(function (el) {
    el.addEventListener('change', function () { el.form && el.form.submit(); });
  });

})();
